export default __webpack_public_path__ + "static/media/contact.df6cbe5b.svg";